import * as React from 'react';

import {
  PictogramDealAttachedDocuments40,
  PictogramPlaceholderImages40,
  PictogramProductTrust40,
  PictogramServicesLegalVerification40,
  PictogramServicesPerson40,
  PictogramValuationPrice40,
} from '@cian/ui-kit-design-tokens/pictograms';

import * as styles from './QuestionsAndAnswersItem.css';
import * as flightStyles from './QuestionsAndAnswersItemFlight.css';

interface IQuestionsAndAnswersItemProps {
  type: 'service' | 'consultant' | 'support' | 'partial' | 'existing' | 'safety';
  flightEnabled: boolean;
  question: string;
  answer: string;
}

const ICONS = {
  service: <PictogramValuationPrice40 color="icon-primary-default" />,
  consultant: <PictogramServicesPerson40 color="icon-primary-default" />,
  support: <PictogramDealAttachedDocuments40 color="icon-primary-default" />,
  partial: <PictogramPlaceholderImages40 color="icon-primary-default" />,
  existing: <PictogramServicesLegalVerification40 color="icon-primary-default" />,
  safety: <PictogramProductTrust40 color="icon-primary-default" />,
};

export const QuestionsAndAnswersItem = ({ flightEnabled, type, question, answer }: IQuestionsAndAnswersItemProps) => {
  const currentStyles = flightEnabled ? flightStyles : styles;

  return (
    <div className={currentStyles['item']}>
      <div className={currentStyles['icon']}>{ICONS[type]}</div>
      <div className={currentStyles['content']}>
        <div className={currentStyles['question']}>{question}</div>
        <div className={currentStyles['answer']}>{answer}</div>
      </div>
    </div>
  );
};
